import {useState, useEffect} from "react";
import {marked} from "marked";
function About() {
const [html, setHtml] = useState<any>('');
const [text, setText] = useState<string>(`
### **Welcome to LensTalk: Your AI-Powered Virtual Video Assistant**  

We’re thrilled to introduce **LensTalk**, an innovative AI assistant designed to transform how you interact with technology. LensTalk leverages video capabilities and AI intelligence to create a seamless, intuitive, and highly engaging experience.  

---

### **Features**  

1. **Intelligent Assistance**  
   LensTalk understands your needs and provides precise, tailored support for various tasks.  

2. **Video-Driven Interaction**  
   Enhance communication with AI through immersive, real-time video assistance.  

3. **Dynamic Learning**  
   LensTalk evolves with you, adapting to your preferences and behaviors for a personalized experience.  

4. **Multilingual Support**  
   Break language barriers with multilingual communication capabilities.  

5. **Accessibility First**  
   Built with inclusivity in mind, LensTalk ensures it’s easy to use for everyone.  

---

### **What to Expect**  

- **Ease of Use**:  
  LensTalk is user-friendly and intuitive, requiring no prior technical knowledge.  

- **Data Privacy**:  
  Your interactions are secure, with robust safeguards to protect your information.  

- **Reliability**:  
  LensTalk provides consistent performance, ensuring it’s ready when you need it most.  

---

### **User Responsibility**  

- **Respectful Usage**:  
  Please interact responsibly with LensTalk and refrain from using it for unethical or harmful purposes.  

- **Feedback**:  
  Your input is valuable! Share your experience to help us improve.  

- **Compliance**:  
  Ensure usage complies with applicable laws and regulations in your region.  

---

### **Disclosure Statement**  

LensTalk is designed to assist and support users in a variety of tasks. However:  
- It is **not a substitute for professional advice** in areas such as law, medicine, or finance.  
- **Privacy and Data**: While we prioritize user privacy, it’s essential to avoid sharing sensitive personal information during interactions.  

By using LensTalk, you agree to adhere to its terms of use and understand its limitations.  

---

**Thank you for choosing LensTalk!**  
We’re excited to be part of your journey and look forward to empowering you with AI-driven video assistance.  

Let us know how LensTalk can make your life easier! 🌟
`);
useEffect(() => {
document.title = "About the Project | LensTalk";
setHtml(marked(text));
}, []);
return (
<>
<h1>About the project</h1>
<div dangerouslySetInnerHTML={{__html: html}}></div>
</>
);
}
export default About;